import config from 'config';
import axios from '@/util/axios';
import { authHeader } from '@/services/authentication';

export default {
    all: () => axios
        .get(`${config.apiUrl}/${config.apiVersion}/assignees`, {
            headers: authHeader(),
        })
        .then(({ data }) => data),
};
